
export default () => {
  const script = document.getElementById('data-for-remove');
  if (!script) {
    return false;
  }
  script.parentNode.removeChild(script);
  return true;
};
